import { Component, OnInit, Input } from '@angular/core';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';
import { PricePipe } from './../../../core/pipes/price.pipe';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AddToCrateButtonComponent } from './../../controls/add-to-crate-button/add-to-crate-button.component';

@Component({
    selector: 'app-product-market-row-item',
    standalone: true,
    imports: [TranslocoPipe, TranslocoCurrencyPipe, PricePipe, RouterLink, CommonModule, AddToCrateButtonComponent],
    templateUrl: './product-market-row-item.component.html',
    styleUrls: ['./product-market-row-item.component.css'],
})
export class ProductMarketRowItemComponent implements OnInit {

  @Input() item;
  @Input() hideCrateButton?:boolean = false;
  @Input() isFeaturedRow: boolean = true;
  @Input() showRestaurantName?:boolean = true;
   
  constructor(public translate: TranslocoService) { }

  ngOnInit(): void {
  }

}
